import { Component, input } from '@angular/core';
import { RdsDividerModule } from '@rds/angular-components';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';

@Component({
  selector: 'inexp-knowledge-user-instructions',
  imports: [RdsDividerModule, SafeHtmlPipe],
  templateUrl: './knowledge-user-instructions.component.html',
  styleUrl: './knowledge-user-instructions.component.scss',
})
export class KnowledgeUserInstructionsComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  userInstructions = input<any[]>();
  userInstructionLongDescription = input<string>();
  hasPublishedItems(): boolean {
    return this.userInstructions()?.some(b => b.published === true) ?? false;
  }
}
